
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-plugin-framework/[url]",
      function () {
        return require("private-next-pages/video-plugin-framework/[url]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-plugin-framework/[url]"])
      });
    }
  